import React, { useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';

import { FormContext } from '../../../customise/contexts/form-context';
import builderActions from '../../../builder/slice-actions/index';
import { RowIcons, IconWrapper } from './add-row.styled';
import { ControlPropType } from '../../ctrl_proptype';

const RowFieldIcons = ({ ctrl }) => {
  const dispatch = useDispatch();
  const { inBuilder } = useContext(FormContext);
  const { control, isEditbarOpen } = useSelector((state) => state.fieldEdit);
  const inPreviewPage = useSelector((state) => state.builder.inPreviewPage);

  const handleDelete = () => {
    dispatch(builderActions.doDeleteElement(ctrl));
  }

  const checkSideBar = () => {
    if (!isEditbarOpen || (isEditbarOpen && control.type === 'add_row')) return true;
    toast.warning('You cannot open multiple sidebars', {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: true,
    });
    return undefined;
  };

  const handleEdit = () => {
    if (checkSideBar()) {
      dispatch(builderActions.doShowEditbar({ editedId: ctrl.internal_id, control: ctrl }));
      dispatch(builderActions.clearFieldError({ editedId: ctrl.internal_id }));
    }
  };

  if (inBuilder && inPreviewPage) return null;

  return (
    <RowIcons>
      <div>
        <IconWrapper onClick={handleEdit}>
          <img src="https://storage.googleapis.com/fplsblog/edit-icon.svg" alt="Settings Icon" />
        </IconWrapper>
      </div>
      <IconWrapper onClick={handleDelete}>
        <img src="https://storage.googleapis.com/fplsblog/Delete.svg" alt="Delete Icon" />
      </IconWrapper>
    </RowIcons>
  );
};

RowFieldIcons.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};

export default RowFieldIcons;
